var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6263 13.3335H5.29297V24.0002C5.29297 28.0002 6.6263 29.3335 10.6263 29.3335H21.293C25.293 29.3335 26.6263 28.0002 26.6263 24.0002V13.3335Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6673 9.33317V10.6665C28.6673 12.1332 27.9606 13.3332 26.0006 13.3332H6.00065C3.96065 13.3332 3.33398 12.1332 3.33398 10.6665V9.33317C3.33398 7.8665 3.96065 6.6665 6.00065 6.6665H26.0006C27.9606 6.6665 28.6673 7.8665 28.6673 9.33317Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5204 6.66659H8.16036C7.70703 6.17325 7.72036 5.41326 8.20036 4.93326L10.0937 3.03992C10.587 2.54659 11.4004 2.54659 11.8937 3.03992L15.5204 6.66659Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8268 6.66659H16.4668L20.0935 3.03992C20.5868 2.54659 21.4001 2.54659 21.8935 3.03992L23.7868 4.93326C24.2668 5.41326 24.2801 6.17325 23.8268 6.66659Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9199 13.3335V20.1868C11.9199 21.2535 13.0933 21.8802 13.9866 21.3068L15.2399 20.4802C15.6933 20.1868 16.2666 20.1868 16.7066 20.4802L17.8933 21.2802C18.7733 21.8668 19.9599 21.2402 19.9599 20.1735V13.3335H11.9199Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift2);
export default __webpack_public_path__ + "static/media/gift2.b398460c1b1c581f8c0246066282819a.svg";
export { ForwardRef as ReactComponent };